import React, { useState } from 'react';
import PropTypes from "prop-types";

import datasetPlaceholderLogo from "~/assets/images/dataset_placeholder_logo.png";

const IndexApp = (props) => {
    const [datasets, setDatasets] = useState(props.datasets);

    const handleSearchDataset = (e) => {
        console.log(e.target.value);
        setDatasets(props.datasets);    // TODO: implement search
    };

    return props.datasets.length > 0 ? <>
        <input
            className = "form-control form-control-lg my-4 rounded-pill"
            type = "text"
            placeholder = "Search dataset..."
            aria-label = ".form-control-lg"
            onChange = { handleSearchDataset }
        />
        {
            datasets.map((item, i) => {
                return <div key = { i } className = "dataset-card card mb-4 mx-auto w-75 shadow rounded-0">
                    <div className = "row g-0">
                        <div className = "col-md-4 overflow-hidden d-flex justify-content-center align-items-center" style = {{ height: 200 }}>
                            <img src = { item.logo != "" ? item.logo : datasetPlaceholderLogo } className = "img-fluid rounded-start h-100" alt = { `${item.title}_logo` } />
                        </div>
                        <div className = "col-md-8">
                            <div className = "card-body">
                                <h5 className = "card-title fw-bold">{ item.title }</h5>
                                <p className = "card-text" dangerouslySetInnerHTML = {{ __html: item.headline }}></p>
                                {
                                    item.tags.length > 0 && <p className = "d-flex flex-wrap">
                                        {
                                            item.tags.map((tag, j) => (
                                                <div key = { j } className = "bg-primary text-light rounded-pill px-3 my-1 me-2 fs-6">
                                                    { tag.label }
                                                </div>
                                            ))
                                        }
                                    </p>
                                }
                                <p className = "card-footer textend border-0 bg-transparent">
                                    <small className = "text-muted">Last updated { item.last_updated }</small>
                                </p>
                                <a href = { item.url } className='stretched-link'></a>
                            </div>
                        </div>
                    </div>
                </div>;
            })
        }
    </> : <div className = "text-center text-muted">
        There are no datasets referenced on 3ia-data at the moment.
    </div>;
};

IndexApp.propTypes = {
    datasets: PropTypes.arrayOf(PropTypes.object)
};

export default IndexApp;
